const firebaseConfig = {
    apiKey: "AIzaSyA0GKvmU606KMwuRy37bHGu2X1dtX0gbGg",
    authDomain: "literary-homunculus.firebaseapp.com",
    databaseURL: "https://literary-homunculus.firebaseio.com",
    projectId: "literary-homunculus",
    storageBucket: "literary-homunculus.appspot.com",
    messagingSenderId: "243950825999",
    appId: "1:243950825999:web:30bfb362c02058c472697a",
    measurementId: "G-CKCPFJNTGZ"
  };

  export { firebaseConfig }